import { split } from "@/dsl/utilty";

type Params<Allowed extends string> = {
  expr       : string,
  allowed    : readonly Allowed[],
  isAvailable: (variant: Allowed) => boolean,
}

export const compiler = <Allowed extends string>({ expr, allowed, isAvailable }: Params<Allowed>): Allowed | undefined => {
  const tokens = split(expr, "||") as Allowed[];
  // validate tokens early
  for (const t of tokens) {
    if (!allowed.includes(t)) {
      console.warn(`[store] Unknown token "${t}". Allowed: ${allowed.join(", ")}`);
    }
  }

  for (const t of tokens) {
    if (allowed.includes(t) && isAvailable(t)) return t;
  }
  return undefined;
}